import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'materials.Topics' | translate }}</h1>
        </div>
        <materials-iframe url="vm.url"></materials-iframe>
    `
})
export default class {
    constructor (MaterialService) {
        this.url = MaterialService.getTopicsUrl();
    }
}




// WEBPACK FOOTER //
// ./src/app/components/materials/topics/index.js